<template>
  <div class="vx-card">
    <div style="margin-left:30px;margin-top:30px">
      <div class="vx-row">
        <div class="vx-col" style="margin-top:4px">
          <label><b>Obd Talk Param Id </b></label>
        </div>
        <div class="vx-col"><input type="number" style="width: -webkit-fill-available;" placeholder="ObdTalk index" v-model="obdTalkParamId" /></div>
        <div class="vx-col">
          <vs-button type="filled" size="small" class="mr-2" @click="getObdTalkParam()">Getir</vs-button>
        </div>
        <div class="vx-col" style="margin-top:4px">
          <label><b>Ecu Action Name </b></label>
        </div>
        <div class="vx-col"><input type="text" readonly="readonly" style="width:550px;" placeholder="Obd Talk Param Açıklama" v-model="obdTalkParamList[0].ecuActionName" /></div>
      </div>
      <div class="vx-row" style="margin-top:15px">
        <div class="vx-col" style="margin-top:4px;margin-bottom:15px">
          <label><b>Baş-Bit İndex </b></label>
        </div>
        <div class="vx-col"><input type="number" style="width: -webkit-fill-available;margin-left:33px" placeholder="İndex Başlangıç" v-model="selectedRow[0].startIndex" /></div>
        <div class="vx-col"><input type="number" style="width: -webkit-fill-available;" placeholder="İndex Bitişx" v-model="selectedRow[0].finishIndex" /></div>
        <div class="vx-col" style="margin-top:4px">
          <label><b>Tür </b></label>
        </div>
        <div class="vx-col" style="margin-top:-3px">
          <v-select name="convertType" :options="convertTypeList" v-model="selectedRow[0].convertType" :reduce="(r) => r.convertType" label="convertType">
            <span slot="no-options">Eşleşen Veri Yok</span>
          </v-select>
        </div>
        <div class="vx-col" style="margin-top:4px">
          <label><b>Dönüş Array </b></label>
        </div>
        <div class="vx-col" style="margin-top:-3px">
          <v-select name="name" :options="arrayLengthList" v-model="selectedRow[0].returnArray" @input="selectedRow[0].returnValueList = [{ value: null }, { value: null }, { value: null }]" :reduce="(r) => r.value" label="name">
            <span slot="no-options">Eşleşen Veri Yok</span>
          </v-select>
        </div>
        <div class="vx-col" style="margin-top:4px">
          <label><b>Description </b></label>
        </div>
        <div class="vx-col"><input type="text" style="width: -webkit-fill-available;" placeholder="Description" v-model="selectedRow[0].description" /></div>
        <div class="vx-col">
          <div class="vx-row" style="">
            <div v-for="(trSerial, j) in selectedRow[0].returnArray" :key="j">
              <div class="vx-row">
                <div class="vx-col" style="margin-top:4px;margin-bottom:15px">
                  <label
                    ><b>Value {{ " " + j }} </b></label
                  >
                </div>
                <div class="vx-col" style="margin-right:20px;margin-left:-15px;">
                  <input type="text" placeholder="Value" v-model="selectedRow[0].returnValueList[j].value" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-row" style="width:60%;justify-content: center;margin-top:20px;margin-bottom:25px">
        <vs-button type="filled" class="mr-2" @click="generateJson()">Generate Json</vs-button>
      </div>
      <div class="vx-row" style="width:60%;justify-content: center;margin-top:20px;margin-bottom:25px">
        <label class="mt-4 mr-5" style=""><b>Masking Value</b></label>
        <vs-input type="number" class="mr-2" v-model="selectedRow[0].maskValue">></vs-input>
      </div>
      <div class="vx-row" style="margin-bottom:50px">
        <!-- Byteları oluşturan  -->
        <div class="vx-col">
          <!-- Byteları oluşturan  -->
          <div class="vx-col">
            <div class="vx-row">
              A
            </div>
            <div v-for="(trSerial, j) in 8" :key="j" class="vx-row">
              <div class="vx-col" style="width: 33px;text-align:right">
                <label style=""
                  ><b> {{ j }} </b></label
                >
              </div>
              <div class="vx-col">
                <vs-checkbox>{{ j }}</vs-checkbox>
              </div>
            </div>
          </div>
          <div class="vx-row">
            <!-- Byteları oluşturan  -->
            <div class="vx-col">
              <div class="vx-row">
                B
              </div>
              <div v-for="(trSerial, j) in 8" :key="j" class="vx-row">
                <div class="vx-col" style="width: 33px;text-align:right">
                  <label style=""
                    ><b> {{ j }} </b></label
                  >
                </div>
                <div class="vx-col">
                  <vs-checkbox>{{ j + 8 }}</vs-checkbox>
                </div>
              </div>
            </div>
            <!-- json param result oluşturan -->
            <div class="vx-col"></div>
            <!-- add butonu -->
            <div class="vx-col"></div>
            <!-- genel JSON text -->
            <div class="vx-col"></div>
          </div>
          <div class="vx-row">
            <!-- Byteları oluşturan  -->
            <div class="vx-col">
              <div class="vx-row">
                C
              </div>
              <div v-for="(trSerial, j) in 8" :key="j" class="vx-row">
                <div class="vx-col" style="width: 33px;text-align:right">
                  <label style=""
                    ><b> {{ j }} </b></label
                  >
                </div>
                <div class="vx-col">
                  <vs-checkbox>{{ j + 16 }}</vs-checkbox>
                </div>
              </div>
            </div>
          </div>
          <div class="vx-row">
            <!-- Byteları oluşturan  -->
            <div class="vx-col">
              <div class="vx-row">
                D
              </div>
              <div v-for="(trSerial, j) in 8" :key="j" class="vx-row">
                <div class="vx-col" style="width: 33px;text-align:right">
                  <label style=""
                    ><b> {{ j }} </b></label
                  >
                </div>
                <div class="vx-col">
                  <vs-checkbox>{{ j + 24 }}</vs-checkbox>
                </div>
              </div>
            </div>
            <!-- json param result oluşturan -->
            <div class="vx-col"></div>
            <!-- add butonu -->
            <div class="vx-col"></div>
            <!-- genel JSON text -->
            <div class="vx-col"></div>
          </div>
        </div>
        <div class="vx-col">
          <div class="vx-row">
            <label><b>Param Result </b></label>
          </div>
          <div class="vx-row">
            <vs-textarea id="jsonText" rows="29" style="width:600px;height:600px" name="jsonText" v-model="jsonText" />
          </div>
        </div>
        <div class="vx-col" style="align-self: center;">
          <vs-button type="filled" class="mr-2" @click="generateJsonList()">></vs-button>
        </div>

        <div class="vx-col">
          <div class="vx-row">
            <label><b>Param List Result </b></label>
          </div>
          <div class="vx-row">
            <vs-textarea id="jsonListText" rows="29" style="width:600px;height:600px" name="jsonListText" v-model="jsonListText" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import { repository } from "@/_services/repository.js";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vSelect from "vue-select";

// Cell Renderer

export default {
  components: {
    AgGridVue,
    VuePerfectScrollbar,
    vSelect,
  },
  data() {
    return {
      obdTalkParamId: null,
      jsonText: null,
      jsonListText: "",
      jsonListToSave: [],
      obdTalkParamList: [{ ecuActionName: null }],
      selectedRow: [
        { maskValue: 0, byteName: null, byteStart: null, byteFinish: null, returnArray: null, returnValueList: [{ value: null }, { value: null }, { value: null }] },
        { byteName: null, byteStart: null, byteFinish: null, returnArray: null },
        { byteName: null, byteStart: null, byteFinish: null, returnArray: null },
        { byteName: null, byteStart: null, byteFinish: null, returnArray: null },
      ],
      bitList: [{ byte: "A0" }, { byte: "A1" }, { byte: "A2" }, { byte: "A3" }, { byte: "A4" }, { byte: "A5" }, { byte: "A6" }, { byte: "A7" }],
      byteList: [
        { byteName: "A", bitOffset: "0-7" },
        { byteName: "B", bitOffset: "8-15" },
        { byteName: "C", bitOffset: "16-23" },
        { byteName: "D", bitOffset: "24-31" },
      ],
      convertTypeList: [{ convertType: "Bit" }, { convertType: "Hex" }, { convertType: "Byte" }],

      arrayLengthList: [
        { name: 1, value: 1 },
        { name: 2, value: 2 },
        { name: 3, value: 3 },
      ],
    };
  },

  computed: {},
  methods: {
    getObdTalkParam: async function() {
      this.$vs.loading();
      this.obdTalkParamList = await repository.getById("ResearchAndDevelopment/getObdTalkParamById" + "/" + this.obdTalkParamId, this.obdTalkParamId).then((r) => r.list);
      this.jsonListToSave = [];
      this.$vs.loading.close();
    },

    resetReturnValueList: async function() {
      this.selectedRow[0].returnValueList = [{ value: null }, { value: null }, { value: null }];

      console.log(this.selectedRow[0]);
    },

    generateJson: async function() {
      this.calculateMask();
      this.jsonText =
        '{"' +
        "Data" +
        '"' +
        ": { " +
        '"Label": ' +
        '"' +
        this.selectedRow[0].description +
        '",' +
        '"StartIndex": ' +
        '"' +
        this.selectedRow[0].startIndex +
        '",' +
        '"FinishIndex": ' +
        '"' +
        this.selectedRow[0].finishIndex +
        '",' +
        '"ConvertType": ' +
        '"' +
        this.selectedRow[0].convertType +
        '",' +
        ' "valueList": [';

      if (this.selectedRow[0].returnValueList[0].value != null) {
        this.jsonText += '{ "value": "' + this.selectedRow[0].returnValueList[0].value + '"}';
      }
      if (this.selectedRow[0].returnValueList[1].value != null) {
        this.jsonText += ',{ "value": "' + this.selectedRow[0].returnValueList[1].value + '"}';
      }
      if (this.selectedRow[0].returnValueList[2].value != null) {
        this.jsonText += ',{ "value": "' + this.selectedRow[0].returnValueList[2].value + '"}';
      }

      this.jsonText += " ]";
      this.jsonText += " } ";
      this.jsonText += " } ";
    },

    calculateMask: async function() {
      this.selectedRow[0].maskValue = (Math.pow(2, 1 + parseInt(this.selectedRow[0].finishIndex) - parseInt(this.selectedRow[0].startIndex)) - 1) * Math.pow(2, parseInt(this.selectedRow[0].startIndex));
    },

    generateJsonList: async function() {
      this.jsonListToSave.push(this.jsonText);

      this.jsonListText = '{"DataList":[';

      this.jsonListToSave.forEach((element, key) => {
        if (key < this.jsonListToSave.length - 1) {
          this.jsonListText += element.toString() + ",";
        } else {
          this.jsonListText += element.toString();
        }
      });

      this.jsonListText += " ]} ";
    },
  },

  beforeMount() {},
  beforeUpdate() {},
  mounted() {},
  created() {},
};
</script>
